import script from "./ImageEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageEditor.vue?vue&type=script&setup=true&lang=ts"

import "./ImageEditor.vue?vue&type=style&index=0&id=67de7a28&lang=scss&scoped=true"
import "./ImageEditor.vue?vue&type=style&index=1&id=67de7a28&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67de7a28"]])

export default __exports__